import { render, staticRenderFns } from "./tariffInput.vue?vue&type=template&id=12f24503&scoped=true&"
import script from "./tariffInput.vue?vue&type=script&lang=js&"
export * from "./tariffInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f24503",
  null
  
)

export default component.exports